module.exports = {"future":"%s restants","past":"il y a %s","s":"quelques secondes","ss":"%d secondes","m":"une minute","mm":"%d minutes","h":"une heure","hh":"%d heures","d":"un jour","dd":"%d jours","M":"un mois","MM":"%d mois","y":"une année","yy":"%d années"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/moment.fr.json
// module id = 668
// module chunks = 1 2